import React, { useEffect ,useState} from 'react'
import { Link,  useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../ApiUrl/ApiUrl';

const Ourfleet = () => {
  const [cars, setCars] = useState([]);
  const navigate= useNavigate()
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get(`${API_URL}/cars`);
        const newData= response.data
        const offercar=newData.filter((item)=>item.offer===false)
        setCars(offercar);
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    };

    fetchCars();
  }, []);

  const HandleView = (id) => {
    navigate(`/car_booking/${id}`);        
  };
  

  return (
    <div>
         <div className="transper" style={{ width: "100%", height: "100px"}}>
         </div>
         <div className="col-lg-12 text-center mt-5">
              <h1 className=''> Our Fleet</h1>
              {/* <p>
                Explore our premium fleet of vehicles, meticulously chosen to
                ensure your comfort and style:
              </p> */}
            </div>
      <div className="site-wrap " id="home-section">
  <div className="site-section fleet">
    <div className="container">
   
      <div className="row">
        {cars?.map((car, index) => (
        <div className="col-lg-4 col-md-6 mb-4">
          <div key={index} className="item-1">
            <a href="#">
              <img
               src={car.images[0]} alt={car.name}
                className="img-fluid"
              />
            </a>
            <div className="item-1-contents">
              <div className="text-center">
                <h3>
                  <a>
                   {car.carName}
                  </a>
                </h3>
                <div className="rent-price">
                  <span>TZS {car.carPrice}</span> Per Day
                </div>
                <button className="btn btn-primary mt-4" onClick={()=> HandleView(car._id)}>
                  Book Now
                </button>
              </div>
         
            </div>
          </div>
        </div>
            ))}
      
    
      </div>
    </div>
  </div>
  
</div>

    </div>
  )
}

export default Ourfleet
